import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Combobox,
  Option,
  makeStyles,
  useId,
} from "@fluentui/react-components";
import { Dismiss12Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { PRESENCE_OPTIONS } from "../GenericComponent/GenericData/presenceOptions";

import "../CSS/QueueForm.css";
const useStyles = makeStyles({
  tagsList: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexWrap: "wrap",
    gap: "0.5rem",
    marginLeft: "5rem",
    width: "100%",
   
  },
 
});

export default function AuthorizedActivity(props) {
  const { t } = useTranslation();
  const styles = useStyles();
  const comboId = useId("combo-multi");
  const selectedListId = `${comboId}-selection`;

  const selectedListRef = useRef(null);
  const comboboxInputRef = useRef(null);

  //  État local
  const [selectedOptions, setSelectedOptions] = useState([]);

  // 🔄 Si queue déjà initialisé → hydrate le state
  useEffect(() => {
    if (Array.isArray(props.queue?.authorizedActivityValues)) {
      setSelectedOptions(props.queue.authorizedActivityValues);
    }
  }, [props.queue]);

  // Quand on sélectionne ou désélectionne dans la combobox
  const onSelect = (event, data) => {
    setSelectedOptions(data.selectedOptions);
    props.setQueue((queue) => ({
      ...queue,
      authorizedActivityValues: data.selectedOptions, //  ici, on travaille sur authorizedActivityValues
    }));
  };

  //  Supprimer un tag
  const onTagClick = (option, index) => {
    const updated = selectedOptions.filter((o) => o !== option);
    setSelectedOptions(updated);

    props.setQueue((queue) => ({
      ...queue,
      authorizedActivityValues: updated,
    }));

    // Gestion focus fluide
    const indexToFocus = index === 0 ? 1 : index - 1;
    const optionToFocus = selectedListRef.current?.querySelector(
      `#${comboId}-remove-${indexToFocus}`
    );
    if (optionToFocus) {
      optionToFocus.focus();
    } else {
      comboboxInputRef.current?.focus();
    }
  };

  const labelledBy =
    selectedOptions.length > 0 ? `${comboId} ${selectedListId}` : comboId;

  return (
    <div>
      {/* Combobox multiselect */}
      <Combobox
        className="dropdown-inline"
        aria-labelledby={labelledBy}
        multiselect
        placeholder={t("SELECT_ACTIVITY")}
        selectedOptions={selectedOptions}
        onOptionSelect={onSelect}
        ref={comboboxInputRef}
        disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
      >
        {PRESENCE_OPTIONS.map((option) => (
          <Option key={option} value={option}>
            {t(`PRESENCE.${option}`)}
          </Option>
        ))}
      </Combobox>
      {selectedOptions.length > 0 && (
        <ul 
          id={selectedListId}
          className={styles.tagsList}
          ref={selectedListRef}
        >
          {selectedOptions.map((option, i) => (
            <li key={option}>
              <Button
                className="btn-tag-activity"
                shape="circular"
                icon={<Dismiss12Regular />}
                iconPosition="after"
                title={t("DELETE")}
                disabled={!props.permissions?.canDelete}
                onClick={() => onTagClick(option, i)}
                id={`${comboId}-remove-${i}`}
                aria-labelledby={`${comboId}-remove ${comboId}-remove-${i}`}
              >
                {t(`PRESENCE.${option}`)}
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
